<div style="color: white;">
  <ion-item>
    <ion-label>Selected Day</ion-label>
    <ion-datetime (ionChange)="onPickedDay($event)" [value]="day"></ion-datetime>
  </ion-item>
</div>
